import { Button } from '@mui/material';
import { styled } from '@mui/styles';

/**
 * Shared Cancel control for dialogs (same styling as Business Choose Plan / Choose Feature).
 */
const DialogCancelButton = styled(Button)(() => ({
  background: '#ffffff',
  color: '#000000',
  border: '1px solid #dedede',
  '&:hover': {
    background: '#ffffff',
    color: '#000000',
    border: '1px solid #dedede',
  },
}));

export default DialogCancelButton;
